interface FeaturePolicyLike {
  allowsFeature(feature: string): boolean;
}

interface DocumentWithFeaturePolicy extends Document {
  permissionsPolicy?: FeaturePolicyLike;
  featurePolicy?: FeaturePolicyLike;
}

function microphonePolicyAllows(documentLike: DocumentWithFeaturePolicy): boolean | undefined {
  const policy = documentLike.permissionsPolicy ?? documentLike.featurePolicy;
  if (!policy || typeof policy.allowsFeature !== "function") return undefined;
  try {
    return policy.allowsFeature("microphone");
  } catch {
    return undefined;
  }
}

function errorName(cause: unknown): string {
  if (cause instanceof DOMException) return cause.name;
  if (typeof cause === "object" && cause !== null && "name" in cause) return String(cause.name);
  return "";
}

export function microphoneStartErrorMessage(
  cause: unknown,
  documentLike = document as DocumentWithFeaturePolicy
): string {
  if (errorName(cause) !== "NotAllowedError") return "无法启动麦克风，请检查设备和浏览器权限";
  if (microphonePolicyAllows(documentLike) === false) {
    return "当前 Salesforce 嵌入页面未向 AI 助手开放麦克风权限，请升级或重新部署 AI 助手组件后刷新重试";
  }
  return "未获得麦克风权限，请在浏览器地址栏允许后重试";
}
